import React from "react";
import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";
import { Col, Container, Image, Row } from "react-bootstrap";
import "./StudentProfile.css";
import "./MemberPage.css";

const markdownComponents = {
    h1({ children }) {
        return <h2>{children}</h2>;
    }
};

function MemberPage({ member }) {
    const [biography, setBiography] = React.useState("");
    const [status, setStatus] = React.useState("loading");

    React.useEffect(() => {
        let active = true;
        setBiography("");
        setStatus(member.biography ? "loading" : "ready");
        if (member.biography) {
            fetch(member.biography)
                .then((response) => {
                    if (!response.ok) throw new Error("Unable to load biography");
                    return response.text();
                })
                .then((text) => {
                    if (active) {
                        setBiography(text);
                        setStatus("ready");
                    }
                })
                .catch(() => { if (active) setStatus("error"); });
        }
        return () => { active = false; };
    }, [member.biography]);

    const position = member.currentPosition;
    return (
        <section className="student-profile member-profile">
            <Container fluid className="project-section">
                <h1 className="white-text">{member.name}</h1>
            </Container>
            <Container fluid>
                <Row className="align-items-start">
                    {member.avatar && (
                        <Col md={4} className="memberpageavataer-region">
                            <Image src={member.avatar} alt={member.name} rounded fluid className="my-4 member-profile-portrait" />
                            <div className="student-profile-summary">
                                <h2>{member.name}</h2>
                                {member.role && <p className="member-profile-role">{member.role}</p>}
                                {member.email && <p><strong>Email</strong><br /><a href={`mailto:${member.email}`}>{member.email}</a></p>}
                                <Link to="/team">Back to Team</Link>
                            </div>
                        </Col>
                    )}
                    <Col md={member.avatar ? 8 : 12} className="markdown-region">
                        {!member.avatar && <p><Link to="/team">Back to Team</Link></p>}
                        {member.education.length > 0 && (
                            <>
                                <h2>Education</h2>
                                {member.education.map((entry, index) => (
                                    <p key={index}>{[entry.period, entry.degree, entry.institution].filter(Boolean).join(" ")}</p>
                                ))}
                            </>
                        )}
                        {position && (position.organization || position.title || position.since) && (
                            <>
                                <h2>Current Position</h2>
                                <p>{[position.title, position.organization, position.since].filter(Boolean).join(" · ")}</p>
                            </>
                        )}
                        {status === "loading" && <p role="status">Loading biography…</p>}
                        {status === "error" && <p role="alert">Unable to load biography. Please try refreshing the page.</p>}
                        <ReactMarkdown components={markdownComponents}>{biography}</ReactMarkdown>
                        {member.email && (
                            <>
                                <h2>Contact information</h2>
                                <p><a href={`mailto:${member.email}`}>{member.email}</a></p>
                            </>
                        )}
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default MemberPage;
